import styled from '@emotion/styled'
import { Link } from 'react-router-dom'
import { Icon as CommonIcon } from 'application/icons'
import { Image as MaxxiaImage } from 'Maxxia/images'

export const MainLogoContainer = styled('button')`
  label: MainLogoContainer;
  margin: 20px;
  z-index: 100;
  border: transparent;
  background: transparent;
  > span {
    color: transparent;
    pointer-events: none;
    position: absolute;
  }
`

export const MenuHamburgerIcon = styled(CommonIcon)`
  label: MenuHamburgerIcon;
  float: right;
  margin-right: 18px;
  cursor: pointer;
`

export const MenuDoubleXImage = styled(MaxxiaImage)`
  label: MenuDoubleXImage;
  height: 88px;
  width: 60px;
  position: absolute;
  right: 300px;
  top: -15px;
  @media (max-width: 719px) {
    visibility: hidden;
  }
`
export const MenuIconDiv = styled.div`
  label: MenuIcon;
  position: absolute;
  top: 8px;
  right: ${(props) => (props.isGov ? '245px' : '210px')};
  @media (max-width: 719px) {
    visibility: hidden;
  }
`

export const MenuTitleDiv = styled.div`
  label: MenuTitleDiv;
  position: absolute;
  display: ${(props) => (props.isShowing ? '' : 'flex')};
  justify-content: flex-end;
  right: 15px;
  top: 30px;
  z-index: 99;
  width: 380px;
  background: ${(props) => (props.isShowing ? 'white' : 'none')};
  @media (max-width: 719px) {
    width: 100%;
    right: 0px;
  }
`

export const MenuWordDiv = styled.div`
  label: MenuWordDiv;
  margin-right: 12px;
  color: ${(props) => props.theme.colors.primary};
  font-weight: ${(props) => props.theme.font.weight.slightBold};
  cursor: pointer;
`

export const MenuContainingDiv = styled.div`
  label: MenuContainingDiv;
  background-color: ${(props) => props.theme.backgrounds.backGround1};
  float: left;
  padding-top: 30px;
  width: 395px;
  box-shadow: -7px 10px 13px -7px rgba(115, 113, 113, 0.75);
  -webkit-box-shadow: -7px 10px 13px -7px rgba(115, 113, 113, 0.75);
  -moz-box-shadow: -7px 10px 13px -7px rgba(115, 113, 113, 0.75);
  @media (max-width: 719px) {
    width: 100%;
    padding-top: 0px;
  }
  div:last-child {
    a {
      padding-left: 0;
    }
  }
`

export const MenuAccordionTitleDiv = styled.div`
  label: MenuAccordionTitleDiv;
  margin-left: 12px;
  margin-bottom: 12px;
  cursor: pointer;
`

export const MenuAccordionTitleSpan = styled.span`
  label: MenuAccordionTitle;
  color: ${(props) =>
    props.isActive ? props.theme.colors.primary : props.theme.colors.navColor};
`

export const MenuAccordionArrow = styled.img`
  label: MenuAccordionArrow;
  width: 11px;
  height: 7px;
  margin-left: 12px;
  background-color: ${(props) =>
    props.isActive ? props.theme.colors.primary : props.theme.colors.navColor};
  transform: ${(props) => (props.isActive ? 'rotate(180deg)' : null)};
`

export const MenuAccordionContainer = styled.div`
  label: MenuAccordionContainer;
  background-color: ${(props) => props.theme.backgrounds.backGround3};
  padding-left: 24px;
  padding-bottom: 6px;
`

export const MenuAccordionComponentDiv = styled.div`
  label: MenuAccordionComponentDiv;
  display: flex;
  justify-content: center;
  margin-right: 12px;
  @media (max-width: 719px) {
    > span {
      width: 100%;
    }
  }
`

export const MenuTitle = styled.p`
  label: MenuTitle;
  margin-bottom: 0px;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.navColor
      : props.theme.colors.textDarkblack};
`

export const MenuValue = styled.p`
  label: MenuValue;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.navColor
      : props.theme.colors.textDarkblack};
  font-weight: 700;
`

export const MenuLinkTitle = styled(Link)`
  label: MenuLinkTitle;
  margin-left: 12px;
  color: ${(props) => props.theme.colors.navColor};
  &:hover {
    color: ${(props) => props.theme.colors.navColor};
  }
`

export const MainNavContainer = styled('div')`
  label: MainNavContainer;
  height: 88px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`
export const MainFlowBlock = styled('div')`
  label: MainFlowBlock;
  width: 40%;
  @media (max-width: 719px) {
    div > span {
      font-size: 9px;
    }
  }
`
export const MainFlowBlockMobile = styled(MainFlowBlock)`
  label: MainFlowBlockMobile;
  width: 92%;
  margin-left: 18px;
`
